<template>
  <MenuContainer>
    <template #header>
      <MenuTitle text="Layout Builder" />
    </template>
    <sp-container flex direction="column" rowgap="var(--menu-content-row-gap)">
      <LayoutOptions />
      <sp-divider></sp-divider>
      <RowComponents />
    </sp-container>
  </MenuContainer>
</template>

<script setup>
import MenuContainer from "#ce/components/SpLayoutBuilder/components/LayoutBuilderContextMenu/ContextMenuContainer.ce.vue";
import MenuTitle from "#ce/components/SpLayoutBuilder/components/LayoutBuilderContextMenu/ContextMenuTitle.ce.vue";
import LayoutOptions from "./LayoutOptions.ce.vue";
import RowComponents from "./RowComponents.ce.vue";
</script>
